import React, { useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import HtmlReportViewer from "../../shared/components/HtmlReportViewer";
import { useOutletContext } from "react-router-dom";

export default function AnalyzeResultsQuality() {
    const { id } = useParams();
    const tableRef = useRef(null);
    const { refgen, options } = useOutletContext();
    

    return (
        <Box
            sx={{
                width: "100%",
                mx: "auto",
            }}
        >
            <Box sx={{ width: "100%", mb: 6 }}>
                <Typography variant="h4">Sequencing quality and assembly quality</Typography>
            </Box>

            <Grid container spacing={4} sx={{ width: "100%", mb: 6 }}>
                <Grid item xs={12} md={6}>
                    <Box sx={{ maxWidth: 760 }}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            This section is available only if at least one FASTQ file was provided.
                        </Typography>

                        <Typography variant="body1">
                            The selected genome reference was: <b>{refgen}</b>
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box
                sx={{
                    width: "100%",
                    borderRadius: 2,
                    mb: 6,
                    background: "#f0f0f0",
                    p: 1,
                    overflowX: "auto",
                }}
                ref={tableRef}
            >
                <Box sx={{ minWidth: { xs: 900, md: "auto" } }}>
                    <HtmlReportViewer />
                </Box>
            </Box>
        </Box>
    );
}